import { render } from "./fundbankinfo.vue?vue&type=template&id=e33caade&scoped=true"
import script from "./fundbankinfo.vue?vue&type=script&lang=js"
export * from "./fundbankinfo.vue?vue&type=script&lang=js"

import "./fundbankinfo.vue?vue&type=style&index=0&id=e33caade&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e33caade"]])

export default __exports__